import { colors } from '@karnott/colors';
import CircledIcon from '../utils/circledIcon';

export const MultiselectIcon = ({ color = '#000', size = 30, backgroundColor = colors('grey'), circled = false }) => (
  <CircledIcon {...{ backgroundColor, circled, size }}>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={circled ? '60%' : '100%'}
      height={circled ? '60%' : '100%'}
      viewBox="0 0 27.716 26.786"
    >
      <g transform="translate(0.75 0.75)">
        <rect
          width="15.498"
          height="15.498"
          rx="3.141"
          transform="translate(0 9.788)"
          fill="none"
          stroke={color}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
        />
        <line
          x1="4.931"
          y2="4.931"
          transform="translate(6.726 15.072)"
          fill="none"
          stroke={color}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
        />
        <line
          x1="2.885"
          y1="2.885"
          transform="translate(3.841 17.118)"
          fill="none"
          stroke={color}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
        />
        <path
          d="M129.539,11.145V9.51a3.141,3.141,0,0,1,3.141-3.141H141.9a3.141,3.141,0,0,1,3.141,3.141v9.215a3.141,3.141,0,0,1-3.141,3.141h-2.053"
          transform="translate(-124.18 -1.474)"
          fill="none"
          stroke={color}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
        />
        <path
          d="M134.9,6.321V4.615a3.141,3.141,0,0,1,3.141-3.141h9.216A3.141,3.141,0,0,1,150.4,4.615v9.216a3.141,3.141,0,0,1-3.141,3.141h-2.047"
          transform="translate(-124.18 -1.474)"
          fill="none"
          stroke={color}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
        />
      </g>
    </svg>
  </CircledIcon>
);
